import { createContext } from 'react';
import { Socket } from 'socket.io-client';

export type ConnectionStatus = 'connected' | 'reconnecting' | 'offline';

export interface WebSocketContextType {
  socket: Socket | null;
  isConnected: boolean;
  connectionError: string | null;
  connectionStatus: ConnectionStatus;
  reconnectEpoch: number;
  joinSession: (sessionId: string) => void;
  leaveSession: (sessionId: string) => void;
  onTranscriptUpdate: (callback: (data: Record<string, unknown>) => void) => void;
  onTranscriptDelete: (callback: (data: Record<string, unknown>) => void) => void;
  onMetadataUpdate: (callback: (data: Record<string, unknown>) => void) => void;
  onMetadataDelete: (callback: (data: Record<string, unknown>) => void) => void;
  onSessionStatusChange: (callback: (data: Record<string, unknown>) => void) => void;
  onGenerationStatus: (callback: (data: Record<string, unknown>) => void) => void;
  onAIResponse: (callback: (data: Record<string, unknown>) => void) => void;
  onAIResponseChunk: (callback: (data: Record<string, unknown>) => void) => void;
  onAIResponseDone: (callback: (data: Record<string, unknown>) => void) => void;
  onAIMutationComplete: (callback: (data: Record<string, unknown>) => void) => void;
  onAIActionPhase: (callback: (data: Record<string, unknown>) => void) => void;
  onAIActionProposed: (callback: (data: Record<string, unknown>) => void) => void;
  onAIActionStatus: (callback: (data: Record<string, unknown>) => void) => void;
  onCompendiumPageUpdated: (callback: (data: Record<string, unknown>) => void) => void;
  onBotVoiceStatus: (callback: (data: Record<string, unknown>) => void) => void;
  onOneLinerUpdate: (callback: (data: Record<string, unknown>) => void) => void;
  offTranscriptUpdate: (callback: (data: Record<string, unknown>) => void) => void;
  offTranscriptDelete: (callback: (data: Record<string, unknown>) => void) => void;
  offMetadataUpdate: (callback: (data: Record<string, unknown>) => void) => void;
  offMetadataDelete: (callback: (data: Record<string, unknown>) => void) => void;
  offSessionStatusChange: (callback: (data: Record<string, unknown>) => void) => void;
  offGenerationStatus: (callback: (data: Record<string, unknown>) => void) => void;
  offAIResponse: (callback: (data: Record<string, unknown>) => void) => void;
  offAIResponseChunk: (callback: (data: Record<string, unknown>) => void) => void;
  offAIResponseDone: (callback: (data: Record<string, unknown>) => void) => void;
  offAIMutationComplete: (callback: (data: Record<string, unknown>) => void) => void;
  offAIActionPhase: (callback: (data: Record<string, unknown>) => void) => void;
  offAIActionProposed: (callback: (data: Record<string, unknown>) => void) => void;
  offAIActionStatus: (callback: (data: Record<string, unknown>) => void) => void;
  offCompendiumPageUpdated: (callback: (data: Record<string, unknown>) => void) => void;
  offBotVoiceStatus: (callback: (data: Record<string, unknown>) => void) => void;
  offOneLinerUpdate: (callback: (data: Record<string, unknown>) => void) => void;
}

export const WebSocketContext = createContext<WebSocketContextType | null>(null);
